import template from './assetFinanceModal.html';
import controller from './assetFinanceModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    loanAppId: '<',
    loanSecurityInfoId: '<',
    lendingCategoryId: '<',
  },
};
